import { ReactNode } from 'react';
import { UserData } from '../../../UserProvider/UserData';
import { OverlayMask } from '../OverlayMask/OverlayMask';
import { Transition } from '../Transition/Transition';

interface Props {
  showing?: boolean;
  user?: UserData;
  onClickLink?: VoidFunction;
  onClickLogout?: VoidFunction;
  onClickOverlay?: VoidFunction;
  children: ReactNode;
}

export const SlideOut = ({ onClickOverlay, showing = false, children }: Props) => (
  <>
    <Transition showing={showing}>
      <OverlayMask onClickOverlay={onClickOverlay} />
    </Transition>

    <Transition showing={showing}>{children}</Transition>
  </>
);
